/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const accountUpdateAIApiKeyRequestAnthropicApiKeyMin = 16;

export const AccountUpdateAIApiKeyRequest = zod.strictObject({
    anthropic_api_key: zod
        .string()
        .min(accountUpdateAIApiKeyRequestAnthropicApiKeyMin)
        .describe('Anthropic API key used by the Form AI'),
});

export type AccountUpdateAIApiKeyRequest = zod.input<
    typeof AccountUpdateAIApiKeyRequest
>;
export type AccountUpdateAIApiKeyRequestOutput = zod.output<
    typeof AccountUpdateAIApiKeyRequest
>;
